import React, {useEffect, useState} from 'react';
import {Footer} from "../components/Elements";
import {Service} from "../Api";

const FooterContainer = props => {
    const [data, setData] = useState({})
    useEffect(() => {
        async function fetchData(url) {
            const res = await Service.get(url, (status, fetched) => fetched);
            setData(res);
        }
        fetchData("assets/data/schema/Footer.json").then(() => null)
    }, []);
    return <Footer {...data}/>;
}

export default FooterContainer;
